module.exports = __webpack_public_path__ + "img/taxi_day_down_selected.173522de.svg";